import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from './ThemeProvider';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const cycleTheme = () => {
    if (theme === 'light') {
      setTheme('system');
    } else if (theme === 'system') {
      setTheme('dark');
    } else {
      setTheme('light');
    }
  };

  return (
    <button
      onClick={cycleTheme}
      className="relative inline-flex items-center bg-gray-200 dark:bg-slate-800 rounded-full p-[3px] w-[52px] h-[30px] shadow-inner border border-gray-300 dark:border-slate-600 cursor-pointer focus:outline-none transition-colors duration-300"
      aria-label="Cambiar tema"
      title="Cambiar tema (Claro / Sistema / Oscuro)"
    >
      {/* Thumb animado (círculo blanco con icono) */}
      <div
        className={`absolute w-[22px] h-[22px] bg-white dark:bg-slate-700 rounded-full shadow-md transform transition-all duration-300 ease-in-out flex items-center justify-center z-10
        ${theme === 'light' ? 'translate-x-0' : ''}
        ${theme === 'system' ? 'translate-x-[12px]' : ''}
        ${theme === 'dark' ? 'translate-x-[24px]' : ''}
        `}
      >
        {theme === 'light' && <Sun className="w-3.5 h-3.5 text-yellow-500" />}
        {theme === 'system' && <Monitor className="w-3.5 h-3.5 text-blue-500 dark:text-blue-400" />}
        {theme === 'dark' && <Moon className="w-3.5 h-3.5 text-blue-400" />}
      </div>
    </button>
  );
}
